import { memo } from 'react'

import clsx from 'clsx'

import '@hotmart/cosmos/dist/styles/utilities/sizing.css'
import '@hotmart/cosmos/dist/styles/utilities/text/text.css'
import '@hotmart/cosmos/dist/loading'

type LoaderProps = {
  full?: boolean
}

const Loader = ({ full = false }: LoaderProps) => {
  const loaderClass = clsx({
    '_d-flex _align-items-center _justify-content-center _w-full': full
  })

  return (
    <div data-test='hot-loading' className={loaderClass}>
      <hot-loading></hot-loading>
    </div>
  )
}

export default memo(Loader)
